export class Product {
	productId: number;
	productName: string;
	productDescription: string;
	sellingAge: number;
	buyingAge: number;
	handlingInstruction: string;
	unitPerIssue: string;
	unitCost: number;
	unitPrice: number;
	productSku: string;
	salesDateStart: Date;
	salesDateEnd: Date;
	supplierId: number;
	manufacturerId: number;
	categoryId: number;
	productImage: string;
	shelfLife: number;
	companySku: string;
	productStartTime: Date;
	productEndTime: Date;
	createdByName: string;
	updatedByName: string;
	categoryName: string;
	supplierName: string;
	supplierAddress: string;
	supplierZipCode: string;
	supplierPhone: string;
	supplierEmail: string;
	manufacturerName: string;
	manufacturerAddress: string;
	manufacturerZipCode: string;
	manufacturerPhone: string;
	manufacturerEmail: string;
	accountingCode: string;
	accountId: number;
	taxRate: number;
	isModifier: boolean;
	productType: string;
	taxOptionId: number;
	universalPricing: boolean;
	registerId: number;
	ticketTypeId: number;
	isUndefinedPrice: boolean;
	isAutoConsume: boolean;
	isPrintTicketOnAutoConsume: boolean;
	compositionId: number;
	inventoried: boolean;
	voucherPackageId: number;
	isNegativeUndefinedPrice: boolean;
	prepTime: number;
	order: number;
	locationId: number;
	locationName: string;
	productPrice: number;
	exclusive: number;
	salesStartTime: Date;
	salesEndTime: Date;
	packageName: string;
	priceByLocation: boolean;
	ticketTypeName: string;
	ticketTypeDescription: string;
	thermalId: number;
	advancedThermalId: number;
	ticketable: boolean;
	scheduleId: number;
	scheduleName: string;
	workflowBuilderId: number;
	sessionGroupId: number;
	sessionGroupDetailId: number;
	sortOrder: number;
	groupName: string;
	productTypeBasedId: number;
	secondaryTicketTemplateId: number;

	// arcade product
	arcadeProduct: string;
	arcadeProductName: string;
	isArcadeType: boolean;
	arcadeType: number;
	arcadeCash: number;
	arcadeBonus: number;

	// session product
	isSessionProduct: boolean;
	siteId: number;
	sessionGroupName: string;
	sessionGroupItems: string;
	isSiteCapacity: boolean;
	timeZoneOffset:number

	productSessionType: number;

	// skidata product
	isIntegrateWithSkiData: boolean;
	skiDataProductId: string;
	skiDataCategory: string;
	isRequireGuestName: boolean;
	isRequireGuestImage: boolean;
	unitPriceWithCurrency: string;

	// calculated fields
	imageBtnIcons: string[];
	isProductType: string;
	quantity : number;
}
